import React from 'react';

const pageStyle: React.CSSProperties = {
    fontFamily: 'Montserrat, sans-serif',
    padding: '2rem',
};

export const MissingBusinessSlugPage = () => (
    <div style={pageStyle}>
        <h1>Staff Importer</h1>
        <p>This app requires a business slug in the URL.</p>
        <p>
            Example: <code>{window.location.origin}/my-studio</code>
        </p>
    </div>
);
